// extracted by mini-css-extract-plugin
export default {"LeftNavigation":"CarouselLeftNavigation_LeftNavigation__1o+dd"};